<template>
    <v-card v-if="pessoa" elevation="4" class="ma-4">
        <v-card-title class="justify-center">
            <h3>INFORMAÇÕES DO USUÁRIO</h3>
        </v-card-title>
        <v-divider verfical></v-divider>
        <v-card-text>
            <h3 class="mb-3" style="font-weight: normal;" v-if="!ehAreaDoUsuario">Nome: <b>{{ pessoa.nome }}</b></h3>
            <h3
                class="mb-3"
                style="font-weight: normal;"
                v-if="!ehAreaDoUsuario"
            >
            É Assinante: <b>{{ inscricao && inscricao.tem_assinatura && !inscricao.assinatura.cancelado ? 'SIM': 'NÃO' }}</b>
            </h3>
            <template v-if="inscricao && inscricao.assinatura">
                <h3
                    class="mb-3"
                    style="font-weight: normal;"
                >
                    Data da Próxima Cobrança: <b :class="`${ new Date() >= new Date(`${inscricao.assinatura.data_cobranca}T23:59:59`) ? 'error' : 'success'}--text`">{{  inscricao.assinatura.data_cobranca | formatDate('DD/MM/YYYY') }}</b>
                </h3>
                <h3
                    class="mb-3"
                    style="font-weight: normal;"
                >
                    Data de Encerramento: <b :class="`${new Date() >= new Date(`${inscricao.assinatura.data_encerramento}T23:59:59`) ? 'error' : 'success'}--text`">{{ inscricao.assinatura.data_encerramento | formatDate('DD/MM/YYYY') }}</b>
                </h3>
                <h3
                    class="mb-3 error--text"
                    style="font-weight: normal;"
                    v-if="inscricao.assinatura.plano.id_efi || inscricao.assinatura.plano.id_efi"
                >
                    Essa Assinatura não pode ser paga no estabelecimento.
                </h3>
                <h3
                    v-if="inscricao.assinatura.plano.vinculado_veiculo && inscricao.assinatura.veiculo"
                    class="mb-3"
                    style="font-weight: normal;"
                >
                    Veiculo Vinculado: <b>{{ inscricao.assinatura.veiculo.marca }} {{ inscricao.assinatura.veiculo.modelo }}</b>
                </h3>
                <v-dialog v-model="dialogConfirmarCancelamento" max-width="500px">
                    <v-card>
                        <v-card-title class="headline">Confirmar Cancelamento</v-card-title>
                        <v-card-text>Você tem certeza que deseja cancelar esta assinatura?</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="dialogConfirmarCancelamento = false">Não</v-btn>
                            <v-btn color="green darken-1" text @click="confirmarCancelamento">Sim</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-layout column justify-center>
                  <template v-if="inscricao.assinatura && !inscricao.assinatura.cancelado &&
                          (inscricao.assinatura.gateway || new Date(inscricao.assinatura.data_encerramento) < new Date())">

                          <v-btn
                              color="error"
                              @click="dialogConfirmarCancelamento = true"
                              :disabled="!autenticado"
                              class="mx-auto"
                          >
                              {{ inscricao.assinatura.gateway ? 'Cancelar Assinatura Automática' : 'Cancelar Assinatura Manual' }}
                          </v-btn>
                          <h5 v-if="!autenticado" class="error--text text-xs-center">*Você precisa confirmar o seu PIN abaixo para cancelar a assinatura.</h5>
                  </template>
                </v-layout>
            </template>
        </v-card-text>
        <v-divider verfical></v-divider>
        <v-card-actions
            class="justify-center white--text"
            v-if="inscricao && inscricao.assinatura"
            :style="{ 'background-color':  new Date() >= new Date(`${inscricao.assinatura.data_encerramento}T23:59:59`) ? 'red' : 'green' }"
        >
            <h2>
            Valor: <b>{{ inscricao.assinatura.plano.valor | currency({fractionCount:  2}) }}</b>
            </h2>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
  props: ['inscricao', 'autenticado', 'appSelected', 'pessoa', 'ehAreaDoUsuario'],
  data: () => ({
    dialogConfirmarCancelamento: false
  }),
  methods: {
    cancelarAssinatura () {
      const assinatura = this.inscricao.assinatura
      if (assinatura.plano.itens && assinatura.plano.itens.length > 0) {
        const payload = {
          method: 'DELETE',
          id: assinatura.plano.id
        }
        this.$store.dispatch('planoComItens', payload).then(() => {
          this.$emit('assinaturaCancelada') // Atualiza a inscrição após o cancelamento
        })
      } else {
        const payload = {
          id_cliente: this.inscricao.cliente,
          id_assinatura: this.inscricao.assinatura.id,
          app: this.appSelected
        }

        this.$store.dispatch('cancelarAssinatura', payload)
          .then(() => {
            this.$emit('show-alert', 'Assinatura cancelada com sucesso')
            this.$emit('assinaturaCancelada') // Atualiza a inscrição após o cancelamento
          })
          .catch((error) => {
            this.$emit('show-alert', `Erro ao cancelar a assinatura: ${error.message}`)
          })
      }
    },
    confirmarCancelamento () {
      this.dialogConfirmarCancelamento = false
      this.cancelarAssinatura()
    }
  }
}
</script>
